import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { TGlobalBannerConfig } from "models/globalBannerConfig.models";
import { services } from "services";
import { QueryAPIKey } from "utils/constants/api.constants";

export default function useGlobalBannerConfig() {
  const { data, status, isLoading, isError, isSuccess, error } = useQuery<
    TGlobalBannerConfig,
    AxiosError
  >({
    queryKey: [QueryAPIKey.GetGlobalBannerConfig],
    queryFn: () => services.env.getGlobalBannerConfig().then((res) => res.data),
  });

  return {
    globalBannerConfig: data,
    status,
    error,
    isLoading,
    isError,
    isSuccess,
  };
}
